import React, { useEffect } from "react";
import { connect } from "react-redux";
import { ApplicationState } from "../store";
import { ProductCrossGroup, ProductsData, UserData } from "../models/types";
import { ThunkDispatch } from "redux-thunk";
import { AnyAction } from "redux";
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import { fetchCrossGroups, fetchCrossProducts, searchProduct, searchProducts } from "../store/products/action";
import { Box, Button, ButtonGroup, CircularProgress, Grid, Snackbar, Tab, Tabs, Typography } from "@material-ui/core";
import { CheckCircleOutline, ErrorOutline } from "@material-ui/icons";
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import Switch from '@material-ui/core/Switch';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import InsertDriveFileIcon from '@material-ui/icons/InsertDriveFile';
import PlayCircleOutlineIcon from '@material-ui/icons/PlayCircleOutline';
import ProductSlider from './ProductSlider';
import ProductCard from './ProductCard';
import LocalHelmet from "./Helmet";
import { appendTreeSelection } from "../store/menu/action";
import ProductBreadcrumb from "./ProductBreadcrumb";
import { addCart } from "../store/users/action";
import ga from "../shared/ga-init";
import { FormattedMessage, useIntl } from "react-intl";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    title: {
      marginBottom: 2,
      height: '60px',
      fontSize: '24px',
      fontWeight: 'bold',
      color: 'black',
    },
    title2: {
      fontSize: '22px',
      fontWeight: 'bold',
      color: 'black',
    },
    description: {
      marginBottom: 2,
      height: '60px',
      fontSize: '14px',
      fontWeight: 'bold',
      color: 'black',
    },
    manufacture: {
      marginBottom: 2,
      height: '20px',
      fontSize: '12px',
      color: '#afafaf',
    },
    price: {
      paddingTop: '40px',
      marginBottom: 5,
      fontSize: '18px',
      fontWeight: 'bold',
      color: '#597eb2',
    },
    priceDiscount: {
      paddingTop: '40px',
      marginBottom: 5,
      fontSize: '18px',
      fontWeight: 'bold',
      color: '#b14f50',
    },
    available: {
      height: '30px',
      fontSize: '12px',
      fontWeight: 'bold',
      color: '#4da451',
    },
    notAvailable: {
      height: '30px',
      fontSize: '12px',
      fontWeight: 'bold',
      color: '#b14f50',
    },
    iconText: {
      paddingBottom: 5,
    },
    availabilityList: {
      paddingTop: '12px',
      display: 'flex',
      flexDirection: 'column',
      gap: '6px',
    },
    availabilityRow: {
      display: 'flex',
      alignItems: 'flex-start',
      gap: '8px',
      fontSize: '13px',
      color: '#333333',
    },
    availabilityIcon: {
      color: '#4da451',
    },
    availabilityUnavailableIcon: {
      color: '#b14f50',
    },
    availabilityTitle: {
      fontWeight: 'bold',
    },
    availabilityAddress: {
      color: '#777777',
      fontSize: '12px',
    },
    availabilityAmount: {
      marginLeft: 'auto',
      color: '#4da451',
      fontWeight: 'bold',
      whiteSpace: 'nowrap',
    },
    mediaSection: {
      display: 'flex',
      flexDirection: 'column',
      gap: '10px',
      width: '100%',
    },
    mediaTitle: {
      fontSize: '14px',
      fontWeight: 'bold',
      color: '#333333',
    },
    mediaList: {
      display: 'flex',
      flexDirection: 'column',
      gap: '8px',
      width: '100%',
    },
    mediaLink: {
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      color: '#597eb2',
      textDecoration: 'none',
      fontSize: '13px',
      '&:hover': {
        textDecoration: 'underline',
      },
    },
    videoFrame: {
      width: '100%',
      maxWidth: '480px',
      aspectRatio: '16 / 9',
      border: 0,
    },
    pos: {
      marginBottom: 12,
      color: 'black'
    },
    link: {
      textDecoration: 'none'
    },
    heading: {
      flexBasis: '33.33%',
      flexShrink: 0,
      fontSize: '14px',
      fontWeight: 'bold',
      color: 'black',
    },
    accordion: {
      border: '1px solid #ebdcc6',
      boxShadow: 'none',
    },
    plusButton: {
      border: '1px solid #ebdcc6',
      borderRadius: '3px',
    },
    minusButton: {
      border: '1px solid #ebdcc6',
      borderRadius: '3px'
    },
    counterButton: {
      border: '1px solid transparent',
      borderLeft: '1px solid #ebdcc6',
      outline: 'none'
    },
    sliderBox: {
      backgroundColor: '#f9f9f9',
      color: '#000000',
      fontSize: 18,
      fontWeight: 'bold'
    },
    productImageBox: {
      display: 'flex',
      gap: '12px',
      width: '100%',
    },
    thumbnailList: {
      display: 'flex',
      flexDirection: 'column',
      gap: '8px',
      width: '74px',
      flexShrink: 0,
    },
    thumbnailButton: {
      width: '64px',
      height: '64px',
      padding: 0,
      border: '1px solid #ebdcc6',
      borderRadius: '3px',
      backgroundColor: '#ffffff',
      overflow: 'hidden',
      minWidth: '64px',
      '&:hover': {
        borderColor: '#597eb2',
      },
    },
    selectedThumbnailButton: {
      borderColor: '#597eb2',
      boxShadow: '0 0 0 1px #597eb2',
    },
    thumbnailImage: {
      width: '100%',
      height: '100%',
      objectFit: 'contain',
    },
    mainImageBox: {
      flexGrow: 1,
      textAlign: 'center',
      minWidth: 0,
    },
    productImage: {
      maxWidth: '100%',
      height: 'auto',
      objectFit: 'contain',
    },
    articleLine: {
      display: 'flex',
      alignItems: 'center',
      gap: '6px',
    },
    copyButton: {
      padding: '2px',
      color: '#4e342e',
      '&:hover': {
        cursor: 'pointer',
        color: '#3a241f',
      },
    },
    crossSection: {
      borderTop: '1px solid #ebdcc6',
      marginTop: theme.spacing(2),
      paddingTop: theme.spacing(3),
    },
    crossTabs: {
      borderBottom: '1px solid #ebdcc6',
      marginBottom: theme.spacing(2),
    },
    crossChildTabs: {
      borderBottom: '1px solid #ebdcc6',
      marginBottom: theme.spacing(2),
      marginTop: -theme.spacing(1),
    },
    crossTab: {
      minWidth: '120px',
      fontSize: '13px',
      fontWeight: 'bold',
    },
    crossProductsGrid: {
      minHeight: '180px',
    },
    crossProgress: {
      display: 'flex',
      justifyContent: 'center',
      padding: theme.spacing(4),
    }
  }),
);

interface PropsFromState {
  language: string;
  loading: boolean;
  errors?: string;
  products: ProductsData[];
  recentProducts: ProductsData[];
  recentProductsLoading: boolean;
  crossGroups: ProductCrossGroup[];
  crossGroupsLoading: boolean;
  crossProductsByGroup: {
    [key: string]: ProductsData[];
  };
  crossProductsLoading: boolean;
  token: UserData["token"];
}

interface propsFromDispatch {
  searchProduct: (token: string, type: string, id: string) => any;
  searchProducts: (token: string, type: string) => any;
  fetchCrossGroups: (token: string, productCode: string) => any;
  fetchCrossProducts: (token: string, productCode: string, groupCode: string) => any;
  addToCart: (request: any) => any;
  appendTreeSelection: (type: string, id: string) => any;
}

interface IProps {
  type: string,
  id?: string
}

type AllProps = IProps & PropsFromState & propsFromDispatch;

const ProductDetails: React.FC<AllProps> = ({
  id,
  type,
  language,
  loading,
  products,
  recentProducts,
  recentProductsLoading,
  crossGroups,
  crossGroupsLoading,
  crossProductsByGroup,
  crossProductsLoading,
  token,
  searchProduct,
  searchProducts,
  fetchCrossGroups,
  fetchCrossProducts,
  addToCart,
  appendTreeSelection
}) => {
  const intl = useIntl();

  const [state, setState] = React.useState({
    checkedVAT: true,
    counter: 1,
    expandDescritption: false,
    expandDetails: false,
    expandOther: false,
    cartToastOpen: false,
    copyToastOpen: false,
    selectedImages: {},
    imageScores: {},
    selectedCrossRootGroup: '',
    selectedCrossChildGroup: '',
  });

  useEffect(() => {
    appendTreeSelection(type, id || '');
    searchProduct(token, type, id || '');
    searchProducts(token, "recent");
    fetchCrossGroups(token, id || '');
    setState((currentState) => ({ ...currentState, selectedCrossRootGroup: '', selectedCrossChildGroup: '' }));
  }, [appendTreeSelection, searchProduct, searchProducts, fetchCrossGroups, token, type, id]);

  useEffect(() => {
    ga.trackPageView()
  }, [type, id])
  
  const handleVATChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setState({ ...state, [event.target.name]: event.target.checked });
  };

  const handleIncrement = () => {
    setState({ ...state, counter: state.counter + 1 });
  };

  const handleDecrement = () => {
    setState({ ...state, counter: Math.max(1, state.counter - 1) });
  };

  const addCart = () => {
    let request = {
      productCode: id,
      quantity: state.counter
    }
    addToCart(request).then(() => {
      setState({
        ...state,
        counter: 1,
        cartToastOpen: true
      });
    });
  };

  const closeCartToast = () => {
    setState({ ...state, cartToastOpen: false });
  };

  const copyArticle = (article?: string) => {
    if (!article) return;
    if (navigator.clipboard) {
      navigator.clipboard.writeText(article);
    }
    setState({ ...state, copyToastOpen: true });
  };

  const closeCopyToast = () => {
    setState({ ...state, copyToastOpen: false });
  };

  const handleExpandDescritption = () => (event: React.ChangeEvent<{}>, isExpanded: boolean) => {
    setState({ ...state, expandDescritption: isExpanded });
  };

  const handleExpandDetails = () => (event: React.ChangeEvent<{}>, isExpanded: boolean) => {
    setState({ ...state, expandDetails: isExpanded });
  };

  const handleExpandOthers = () => (event: React.ChangeEvent<{}>, isExpanded: boolean) => {
    setState({ ...state, expandOther: isExpanded });
  };

  const classes = useStyles();
  const productList = Array.isArray(products) ? products : [products].filter(Boolean);
  const getProductImages = (product: ProductsData) => {
    return Array.isArray(product?.image)
      ? product.image.filter((image) => image?.img)
      : Object.values(product?.image || {}).filter((image: any) => image?.img) as any;
  };
  const getImageUrl = (image?: any) => image?.img ? process.env.REACT_APP_IMAGE_HOST + '/files/product_images/' + image.img : '';
  const getProductAmounts = (product: ProductsData) => {
    return Array.isArray(product?.amount)
      ? product.amount.filter((amount) => Number(amount?.amount || 0) > 0)
      : Object.values(product?.amount || {}).filter((amount: any) => Number(amount?.amount || 0) > 0) as any;
  };
  const getProductFiles = (product: ProductsData) => {
    return Array.isArray(product?.file)
      ? product.file.filter((file) => file?.name)
      : Object.values(product?.file || {}).filter((file: any) => file?.name) as any;
  };
  const getProductVideos = (product: ProductsData) => {
    return Array.isArray(product?.video)
      ? product.video.filter((video) => video?.video)
      : Object.values(product?.video || {}).filter((video: any) => video?.video) as any;
  };
  const getLocalizedText = (value?: any) => {
    if (!value) return '';
    if (typeof value === 'string') return value.trim();
    return String(value?.[language] || value?.lv || value?.en || '').trim();
  };
  const hasDescription = (product: ProductsData) => Boolean(getLocalizedText(product?.description));
  const hasSpecification = (product: ProductsData) => getProductFiles(product).length > 0 || getProductVideos(product).length > 0;
  const hasAdditionalInfo = (product: ProductsData) => false;
  const getCrossTabGroups = (groups: ProductCrossGroup[]) => {
    return (groups || []).filter((group) => Number(group.productCount || 0) > 0);
  };
  const getChildGroups = (group?: ProductCrossGroup) => {
    return (group?.children || []).filter((child) => Number(child.productCount || 0) > 0);
  };
  const getGroupLabel = (group: ProductCrossGroup) => {
    const title = getLocalizedText(group.title);
    return `${title || group.code}${group.productCount ? ` (${group.productCount})` : ''}`;
  };
  const formatAmount = (amount: number) => {
    return Number(amount || 0).toLocaleString(undefined, {
      minimumFractionDigits: Number(amount || 0) % 1 === 0 ? 0 : 2,
      maximumFractionDigits: 4,
    });
  };
  const getFileUrl = (file: any) => file?.name ? process.env.REACT_APP_IMAGE_HOST + '/files/product_files/' + file.name : '';
  const getVideoEmbedUrl = (video: any) => {
    const value = String(video?.video || '').trim();
    if (!value) return '';
    const watchMatch = value.match(/[?&]v=([^&]+)/);
    const shortMatch = value.match(/youtu\.be\/([^?&]+)/);
    const embedMatch = value.match(/embed\/([^?&]+)/);
    const videoId = watchMatch?.[1] || shortMatch?.[1] || embedMatch?.[1] || value;
    return videoId.startsWith('http') ? videoId : 'https://www.youtube.com/embed/' + videoId;
  };
  const getMetricText = (product: ProductsData) => {
    const metrics: any = product?.metrics;
    if (!metrics) return '';
    if (typeof metrics === 'string') return metrics;

    const value = metrics.value || metrics;
    return value?.[language] || value?.lv || value?.en || metrics.code || '';
  };
  const getPriceText = (product: ProductsData) => {
    const value = state.checkedVAT ? product?.priceVAT : product?.price;
    const price = parseFloat(value as any);
    const metricText = getMetricText(product);

    return `${isNaN(price) ? '' : price.toFixed(2)}${metricText ? ` / ${metricText}` : ''}`;
  };
  const getProductSchema = (product: ProductsData) => {
    const name = getLocalizedText(product?.title);
    const description = getLocalizedText(product?.description) || name;
    const imageUrl = getImageUrl(getProductImages(product)[0]);
    const price = parseFloat(product?.price as any);
    const canonical = `${window.location.origin}/product/${product.code}`;

    return {
      "@context": "https://schema.org",
      "@type": "Product",
      "name": name,
      "description": description,
      "sku": product.code,
      "mpn": product.article || product.code,
      ...(imageUrl ? { "image": [imageUrl] } : {}),
      ...(product?.supplier?.title ? {
        "brand": {
          "@type": "Brand",
          "name": product.supplier.title
        }
      } : {}),
      "offers": {
        "@type": "Offer",
        "url": canonical,
        "priceCurrency": product.ccy || "EUR",
        ...(isNaN(price) ? {} : { "price": price.toFixed(2) }),
        "availability": product.available ? "https://schema.org/InStock" : "https://schema.org/PreOrder",
        "itemCondition": "https://schema.org/NewCondition"
      }
    };
  };
  const selectedCrossRootGroup = (state as any).selectedCrossRootGroup || '';
  const selectedCrossChildGroup = (state as any).selectedCrossChildGroup || '';
  const crossTabGroups = getCrossTabGroups(crossGroups);
  const activeCrossRootGroup = crossTabGroups.find((group) => group.code === selectedCrossRootGroup) || crossTabGroups[0];
  const activeCrossChildGroups = getChildGroups(activeCrossRootGroup);
  const activeCrossGroupCode = activeCrossChildGroups.length
    ? (activeCrossChildGroups.some((group) => group.code === selectedCrossChildGroup)
      ? selectedCrossChildGroup
      : activeCrossChildGroups[0].code)
    : activeCrossRootGroup?.code || '';
  const activeCrossDisplayGroup = activeCrossChildGroups.find((group) => group.code === activeCrossGroupCode) || activeCrossRootGroup;
  const selectedCrossProducts = activeCrossGroupCode ? crossProductsByGroup[activeCrossGroupCode] || [] : [];

  useEffect(() => {
    const firstRootGroup = crossTabGroups[0];
    if (!firstRootGroup || !id || !token) return;

    const rootGroupExists = crossTabGroups.some((group) => group.code === selectedCrossRootGroup);
    const nextRootGroup = rootGroupExists ? selectedCrossRootGroup : firstRootGroup.code;
    const rootGroup = crossTabGroups.find((group) => group.code === nextRootGroup) || firstRootGroup;
    const childGroups = getChildGroups(rootGroup);
    const childGroupExists = childGroups.some((group) => group.code === selectedCrossChildGroup);
    const nextChildGroup = childGroups.length
      ? (childGroupExists ? selectedCrossChildGroup : childGroups[0].code)
      : '';
    const nextGroup = nextChildGroup || nextRootGroup;

    if (nextRootGroup !== selectedCrossRootGroup || nextChildGroup !== selectedCrossChildGroup) {
      setState((currentState: any) => ({
        ...currentState,
        selectedCrossRootGroup: nextRootGroup,
        selectedCrossChildGroup: nextChildGroup,
      }));
    }

    if (!crossProductsByGroup[nextGroup] && !crossProductsLoading) {
      fetchCrossProducts(token, id, nextGroup);
    }
  }, [crossTabGroups, crossProductsByGroup, crossProductsLoading, fetchCrossProducts, id, selectedCrossChildGroup, selectedCrossRootGroup, token]);

  const handleCrossGroupChange = (event: React.ChangeEvent<{}>, groupCode: string) => {
    const rootGroup = crossTabGroups.find((group) => group.code === groupCode);
    const childGroups = getChildGroups(rootGroup);
    const nextGroup = childGroups[0]?.code || groupCode;

    setState({
      ...state,
      selectedCrossRootGroup: groupCode,
      selectedCrossChildGroup: childGroups[0]?.code || '',
    });
    if (id && !crossProductsByGroup[nextGroup]) {
      fetchCrossProducts(token, id, nextGroup);
    }
  };

  const handleCrossChildGroupChange = (event: React.ChangeEvent<{}>, groupCode: string) => {
    setState({ ...state, selectedCrossChildGroup: groupCode });
    if (id && !crossProductsByGroup[groupCode]) {
      fetchCrossProducts(token, id, groupCode);
    }
  };

  useEffect(() => {
    const currentProductList = Array.isArray(products) ? products : [products].filter(Boolean);
    currentProductList.forEach((product) => {
      const images = getProductImages(product);
      if (!images.length) return;

      setState((currentState: any) => currentState.selectedImages?.[product.code]
        ? currentState
        : ({
            ...currentState,
            selectedImages: {
              ...currentState.selectedImages,
              [product.code]: images[0].img,
            },
          })
      );

      images.forEach((productImage, index) => {
        const imageUrl = getImageUrl(productImage);
        if (!imageUrl) return;

        const loadedImage = new Image();
        loadedImage.onload = () => {
          const score = (loadedImage.naturalWidth || 0) * (loadedImage.naturalHeight || 0) - index;
          setState((currentState: any) => {
            const currentScores = currentState.imageScores || {};
            if (currentScores[productImage.img]) return currentState;

            const currentSelectedImage = currentState.selectedImages?.[product.code] || images[0].img;
            const currentScore = currentScores[currentSelectedImage] || 0;

            return {
              ...currentState,
              imageScores: {
                ...currentScores,
                [productImage.img]: score,
              },
              selectedImages: {
                ...currentState.selectedImages,
                [product.code]: score > currentScore ? productImage.img : currentSelectedImage,
              },
            };
          });
        };
        loadedImage.src = imageUrl;
      });
    });
  }, [products]);

  return (
    <>
      {productList[0] ? (
        <LocalHelmet
          title={getLocalizedText(productList[0].title) || "RetroStyle"}
          description={getLocalizedText(productList[0].description) || getLocalizedText(productList[0].title) || "RetroStyle"}
          image={getImageUrl(getProductImages(productList[0])[0])}
          canonical={`${window.location.origin}/product/${productList[0].code}`}
          type="product"
          structuredData={getProductSchema(productList[0])}
        />
      ) : null}
      {!loading ? productList.map(product => (
        <Box pl={2} pr={2} pt={3} pb={2}>
          <ProductBreadcrumb />
          <Grid
            container
            spacing={0}
            direction="row"
            justify="center"
          >
            <Grid item xs={12} sm={12} >
              <Typography component="h1" className={classes.title}>
                {product?.title[language] || ''}
              </Typography>
              <Grid
                container
                spacing={2}
                direction="row"
                justify="center"
              >
                <Grid item xs={12} sm={6} md={6} >
                  <Box className={classes.productImageBox}>
                    {getProductImages(product).length > 1 ? (
                      <Box className={classes.thumbnailList}>
                        {getProductImages(product).map((productImage: any) => {
                          const selectedImage = (state as any).selectedImages?.[product.code] || getProductImages(product)[0]?.img;
                          return (
                            <Button
                              key={productImage.img}
                              className={`${classes.thumbnailButton} ${selectedImage === productImage.img ? classes.selectedThumbnailButton : ''}`}
                              onClick={() => setState({
                                ...state,
                                selectedImages: {
                                  ...(state as any).selectedImages,
                                  [product.code]: productImage.img,
                                },
                              })}
                            >
                              <img
                                src={getImageUrl(productImage)}
                                alt={productImage.description || product?.title[language] || ''}
                                className={classes.thumbnailImage}
                              />
                            </Button>
                          );
                        })}
                      </Box>
                    ) : null}
                    <Box className={classes.mainImageBox}>
                      <img
                        src={getImageUrl(getProductImages(product).find((productImage: any) => productImage.img === ((state as any).selectedImages?.[product.code] || getProductImages(product)[0]?.img)) || getProductImages(product)[0])}
                        alt={getProductImages(product)[0]?.description || product?.title[language] || ''}
                        className={classes.productImage}
                      />
                    </Box>
                  </Box>
                </Grid>
                <Grid item xs={12} sm={6} md={6} >
                  {product?.supplier.title ? (
                    <Typography component="h2" className={classes.manufacture}>
                      {product?.supplier.title || ''}
                    </Typography>
                  ) : (null)}
                  {product?.title[language] ? (
                    <Typography className={classes.title2}>
                      {product?.title[language] || ''}
                    </Typography>
                  ) : (null)}
                  <Typography className={`${classes.manufacture} ${classes.articleLine}`}>
                    <FormattedMessage id="product.article" />: {product?.article || ''}
                    {product?.article ? (
                      <FileCopyIcon
                        fontSize="small"
                        className={classes.copyButton}
                        onClick={() => copyArticle(product?.article)}
                      />
                    ) : null}
                  </Typography>
                  <Typography className={classes.price}>
                    € {getPriceText(product)}
                  </Typography>
                  <Typography>
                    <FormattedMessage id="cart.withoutVAT" /> <Switch
                      checked={state.checkedVAT}
                      onChange={handleVATChange}
                      name="checkedVAT"
                      inputProps={{ 'aria-label': intl.formatMessage({ id: "aria.secondaryCheckbox" }) }}
                    /> <FormattedMessage id="cart.withVAT" />
                  </Typography>
                  {getProductAmounts(product).length > 0 ? (
                    <Typography>
                      <Typography>

                        <Grid container spacing={2} direction="row" alignItems="center">
                          <Grid item>
                            <ButtonGroup size="medium" aria-label={intl.formatMessage({ id: "aria.quantitySelector" })}>
                              <Button className={classes.minusButton} onClick={handleDecrement}>-</Button>
                              <Button className={classes.counterButton}>{state.counter}</Button>
                              <Button className={classes.plusButton} onClick={handleIncrement}>+</Button>
                            </ButtonGroup>
                          </Grid>
                          <Grid item>
                            <Button variant="contained" color="secondary" onClick={addCart}><FormattedMessage id="product.addToCart" /></Button>
                          </Grid>
                        </Grid>
                      </Typography>
                      <Typography component="span" className={classes.available}>
                        <Box pt={2}>
                          <Box className={classes.availabilityList}>
                            {getProductAmounts(product).map((stockAmount: any) => (
                              <Box className={classes.availabilityRow} key={`${stockAmount.stockCode}-${stockAmount.stockTitle}`}>
                                <CheckCircleOutline fontSize="small" className={classes.availabilityIcon} />
                                <Box>
                                  <Box className={classes.availabilityTitle}>{getLocalizedText(stockAmount.stockTitleValue) || stockAmount.stockTitle}</Box>
                                  {stockAmount.stockAddress || stockAmount.stockShortAddress ? (
                                    <Box className={classes.availabilityAddress}>
                                      {stockAmount.stockAddress || stockAmount.stockShortAddress}
                                    </Box>
                                  ) : null}
                                </Box>
                                <Box className={classes.availabilityAmount}>{formatAmount(stockAmount.amount)}</Box>
                              </Box>
                            ))}
                          </Box>
                        </Box>
                      </Typography>
                    </Typography>
                  ) : (
                    <Typography component="span" className={classes.notAvailable}>
                      <Box pt={2}>
                        <Grid container direction="row" alignItems="center">
                          <Grid item>
                            <ErrorOutline className={classes.availabilityUnavailableIcon} />
                          </Grid>
                          <Grid item>
                            <Box pb={0.7} pl={1}><FormattedMessage id="product.onRequest" /></Box>
                          </Grid>
                        </Grid>
                      </Box>
                    </Typography>
                  )}

                  {hasDescription(product) ? (
                    <Box pt={3}>
                      <Accordion className={classes.accordion} expanded={state.expandDescritption} onChange={handleExpandDescritption()} >
                        <AccordionSummary
                          expandIcon={state.expandDescritption ? <RemoveIcon /> : <AddIcon />}
                          aria-controls="panel1bh-content"
                          id="panel1bh-header"
                        >
                          <Typography className={classes.heading}><FormattedMessage id="product.description" /></Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <Typography>
                            {getLocalizedText(product?.description)}
                          </Typography>
                        </AccordionDetails>
                      </Accordion>
                    </Box>
                  ) : null}
                  {hasSpecification(product) ? (
                    <Box pt={1}>
                      <Accordion className={classes.accordion} expanded={state.expandDetails} onChange={handleExpandDetails()}>
                        <AccordionSummary
                          expandIcon={state.expandDetails ? <RemoveIcon /> : <AddIcon />}
                          aria-controls="panel2bh-content"
                          id="panel2bh-header"
                        >
                          <Typography className={classes.heading}><FormattedMessage id="product.specification" /></Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <Box className={classes.mediaSection}>
                            {getProductFiles(product).length > 0 ? (
                              <Box>
                                <Typography className={classes.mediaTitle}><FormattedMessage id="profile.document" /></Typography>
                                <Box className={classes.mediaList}>
                                  {getProductFiles(product).map((file: any) => (
                                    <a
                                      key={file.id || file.name}
                                      href={getFileUrl(file)}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      className={classes.mediaLink}
                                    >
                                      <InsertDriveFileIcon fontSize="small" />
                                      <span>{file.descr || file.name}</span>
                                    </a>
                                  ))}
                                </Box>
                              </Box>
                            ) : null}
                            {getProductVideos(product).length > 0 ? (
                              <Box>
                                <Typography className={classes.mediaTitle}><FormattedMessage id="gallery.video" /></Typography>
                                <Box className={classes.mediaList}>
                                  {getProductVideos(product).map((video: any) => (
                                    <Box key={video.id || video.video}>
                                      <a
                                        href={String(video.video).startsWith('http') ? video.video : getVideoEmbedUrl(video)}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className={classes.mediaLink}
                                      >
                                        <PlayCircleOutlineIcon fontSize="small" />
                                        <span>{video.video}</span>
                                      </a>
                                      <iframe
                                        title={video.video}
                                        src={getVideoEmbedUrl(video)}
                                        className={classes.videoFrame}
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                        allowFullScreen
                                      />
                                    </Box>
                                  ))}
                                </Box>
                              </Box>
                            ) : null}
                          </Box>
                        </AccordionDetails>
                      </Accordion>
                    </Box>
                  ) : null}
                  {hasAdditionalInfo(product) ? (
                    <Box pt={1} pb={3}>
                      <Accordion className={classes.accordion} expanded={state.expandOther} onChange={handleExpandOthers()}>
                        <AccordionSummary
                          expandIcon={state.expandOther ? <RemoveIcon /> : <AddIcon />}
                          aria-controls="panel3bh-content"
                          id="panel3bh-header"
                        >
                          <Typography className={classes.heading}><FormattedMessage id="product.additionalInfo" /></Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <Typography />
                        </AccordionDetails>
                      </Accordion>
                    </Box>
                  ) : null}
                </Grid>

              </Grid>
              {crossTabGroups.length > 0 ? (
                <Box className={classes.crossSection}>
                  <Typography component="h2" className={classes.title2}>
                    <FormattedMessage id="product.linkedProducts" />
                  </Typography>
                  <Tabs
                    value={activeCrossRootGroup?.code || crossTabGroups[0]?.code}
                    onChange={handleCrossGroupChange}
                    indicatorColor="secondary"
                    textColor="secondary"
                    variant="scrollable"
                    scrollButtons="auto"
                    className={classes.crossTabs}
                  >
                    {crossTabGroups.map((group) => (
                      <Tab
                        key={group.code}
                        value={group.code}
                        label={getGroupLabel(group)}
                        className={classes.crossTab}
                      />
                    ))}
                  </Tabs>
                  {activeCrossChildGroups.length > 0 ? (
                    <Tabs
                      value={activeCrossGroupCode}
                      onChange={handleCrossChildGroupChange}
                      indicatorColor="secondary"
                      textColor="secondary"
                      variant="scrollable"
                      scrollButtons="auto"
                      className={classes.crossChildTabs}
                    >
                      {activeCrossChildGroups.map((group) => (
                        <Tab
                          key={group.code}
                          value={group.code}
                          label={getGroupLabel(group)}
                          className={classes.crossTab}
                        />
                      ))}
                    </Tabs>
                  ) : null}
                  {activeCrossDisplayGroup ? (
                    <Box pb={2}>
                      <Typography component="h3" className={classes.title2}>
                        {getGroupLabel(activeCrossDisplayGroup)}
                      </Typography>
                    </Box>
                  ) : null}
                  {crossProductsLoading && !selectedCrossProducts.length ? (
                    <Box className={classes.crossProgress}>
                      <CircularProgress />
                    </Box>
                  ) : (
                    <Grid container spacing={2} className={classes.crossProductsGrid}>
                      {selectedCrossProducts.map((crossProduct) => (
                        <Grid item xs={12} sm={6} md={3} key={crossProduct.code}>
                          <ProductCard product={crossProduct} language={language} />
                        </Grid>
                      ))}
                    </Grid>
                  )}
                </Box>
              ) : crossGroupsLoading ? (
                <Box className={classes.crossProgress}>
                  <CircularProgress />
                </Box>
              ) : null}
            </Grid>
          </Grid>
        </Box>
      )) : null}
      <Box pt={2} pb={1} pl={2} pr={2} bgcolor="#f9f9f9" className={classes.sliderBox}>
        <ProductSlider title="product.recentProducts" dataLoading={recentProductsLoading} data={recentProducts} />
      </Box>
      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        open={state.cartToastOpen}
        autoHideDuration={3000}
        onClose={closeCartToast}
        message={<FormattedMessage id="product.addedToCart" />}
      />
      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        open={(state as any).copyToastOpen}
        autoHideDuration={2000}
        onClose={closeCopyToast}
        message={<FormattedMessage id="product.articleCopied" />}
      />
    </>
  );
};

const mapStateToProps = ({ language, products, user }: ApplicationState) => ({
  language: language.language,
  loading: products.loadingId,
  errors: products.errors,
  products: products.product,
  recentProducts: products.viewedProducts,
  recentProductsLoading: products.viewedLoading,
  crossGroups: products.crossGroups,
  crossGroupsLoading: products.crossGroupsLoading,
  crossProductsByGroup: products.crossProductsByGroup,
  crossProductsLoading: products.crossProductsLoading,
  token: user.user["token"]
});

const mapDispatchToProps = (dispatch: ThunkDispatch<any, any, AnyAction>) => {
  return {
    searchProduct: (token: string, type: string, id: string) => {
      dispatch(searchProduct(token, type, id));
    },
    searchProducts: (token: string, type: string) => {
      dispatch(searchProducts(token, type));
    },
    fetchCrossGroups: (token: string, productCode: string) => {
      dispatch(fetchCrossGroups(token, productCode));
    },
    fetchCrossProducts: (token: string, productCode: string, groupCode: string) => {
      dispatch(fetchCrossProducts(token, productCode, groupCode));
    },
    appendTreeSelection: (type: string, id: string) => {
      dispatch(appendTreeSelection(type, id));
    },
    addToCart: (request: any) => {
      return dispatch(addCart(request));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductDetails);
